export const ArrowLeftIcon = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3332 10.1009H4.6665M4.6665 10.1009L10.4998 15.9342M4.6665 10.1009L10.4998 4.26758"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
